import NotificationTemplateEdit from './NotificationTemplateEdit';

export default NotificationTemplateEdit;
